module.exports = __webpack_public_path__ + "static/media/ic_zoom_in.24ef3ae8.svg";